/* unplugin-vue-components disabled */import { render } from "./after_sale_list.vue?vue&type=template&id=7a21af16&scoped=true"
import script from "./after_sale_list.vue?vue&type=script&lang=js"
export * from "./after_sale_list.vue?vue&type=script&lang=js"

import "./after_sale_list.vue?vue&type=style&index=0&id=7a21af16&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a21af16"]])

export default __exports__